import { DecimalPipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { IonicModule } from '@ionic/angular';
import { MessageService } from 'primeng/api';
import { IonicStorageModule } from '@ionic/storage-angular';
import { MessageModule } from 'primeng/message';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import {
  DataService,
  dataServiceFactory,
  ServerErrorInterceptor,
  RefreshTokenInterceptor,
  PrimaveraInterceptor,
} from '@telus/d2c-core';
import {
  AuthorizationService,
  Address360Service,
  AddressService,
  TerritoryAddressService,
  K2ViewCustomerDataService,
  K2ViewInteractionService,
  KnockService,
  AttachmentService,
  AmsService,
  SalesEventService,
  EventAssignmentService,
  VendorGroupService,
  VendorSalesRepService,
  RepRosterService,
  PicklistService,
  ValueService,
  ConfigService,
  UserService,
  DropPermissionService,
  D2CGeoService,
  WalklistService,
  TerritoryService,
  FeatureCollectionService,
  FsaService,
  MyWorldService,
  RouteOptimizerService,
  InsightsService,
  DsaService,
  CPMSService,
  RuntimeConfigService,
  initRuntimeConfig,
} from '@telus/d2c-core/services';

import { SafeContentPipe } from '@telus/d2c-ui-common';
import { ENV, environment } from 'env/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInit } from './app.init';
import { ErrorModule } from './pages/d2c-central/error-page/error.module';
import {
  AuthModule,
  AuthService,
  PrimaveraAuthService,
  RoleInterceptorService,
} from '@telus/d2c-core/auth';
import { D2CCentral } from '@telus/d2c-core';
import { D2CUser, PrimaveraD2CUser } from '@telus/d2c-core';
import { TranslocoRootModule } from '@telus/d2c-core/i18n/transloco-root.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgPrimeModule } from '@telus/d2c-ui-common/primeng';

export function appInitializerFactory(appInit: AppInit) {
  return () => appInit.initApp();
}

@NgModule({
  imports: [
    TranslocoRootModule,
    BrowserAnimationsModule,
    TranslocoLocaleModule.forRoot(),
    BrowserModule,
    AuthModule.forRoot(),
    AppRoutingModule,
    ErrorModule,
    HttpClientModule,
    FormsModule,
    NgPrimeModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    IonicStorageModule.forRoot(),
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule,
    SafeContentPipe,
    MessageModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BrowserAnimationsModule,
  ],
  declarations: [AppComponent],
  providers: [
    provideNgxMask(),
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RoleInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass:
        environment.environment === 'local'
          ? RefreshTokenInterceptor
          : PrimaveraInterceptor,
      multi: true,
    },
    { provide: ENV, useValue: environment },
    {
      provide: DataService,
      useFactory: dataServiceFactory,
      deps: [HttpClient],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      multi: true,
      deps: [AppInit],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initRuntimeConfig,
      multi: true,
      deps: [RuntimeConfigService],
    },
    {
      provide: AuthService,
      useClass:
        environment.environment === 'local'
          ? AuthService
          : PrimaveraAuthService,
    },
    {
      provide: D2CUser,
      useClass:
        environment.environment === 'local' ? D2CUser : PrimaveraD2CUser,
    },
    D2CCentral,
    KnockService,
    Address360Service,
    K2ViewInteractionService,
    K2ViewCustomerDataService,
    AddressService,
    TerritoryAddressService,
    AuthorizationService,
    AttachmentService,
    AmsService,
    SalesEventService,
    EventAssignmentService,
    VendorGroupService,
    VendorSalesRepService,
    RepRosterService,
    UserService,
    PicklistService,
    ValueService,
    DropPermissionService,
    ConfigService,
    D2CGeoService,
    WalklistService,
    TerritoryService,
    FeatureCollectionService,
    FsaService,
    MyWorldService,
    RouteOptimizerService,
    InsightsService,
    MessageService,
    DsaService,
    CPMSService,
  ],
  exports: [NgPrimeModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
